// extracted by mini-css-extract-plugin
var _1 = "TextareaControl-module__animatedBackground--nfm4Y";
var _2 = "TextareaControl-module__error--y_6Sf";
var _3 = "TextareaControl-module__errorContainer--powJI";
var _4 = "TextareaControl-module__errorIcon--tipti";
var _5 = "TextareaControl-module__inlineError--olfKe";
var _6 = "TextareaControl-module__input--NFnKZ";
var _7 = "TextareaControl-module__label--UDasM";
var _8 = "TextareaControl-module__textAreaContainer--N3mlK";
export { _1 as "animatedBackground", _2 as "error", _3 as "errorContainer", _4 as "errorIcon", _5 as "inlineError", _6 as "input", _7 as "label", _8 as "textAreaContainer" }
